import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_WORDPRESS_URL,
  timeout: 50000
})

export default api
